module.exports = __webpack_public_path__ + "static/media/Chun.224d47e0.png";